import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/dcm-2020/dcm-2020.github.io/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <InlineNotification mdxType="InlineNotification">
  
**Best Paper Award:** The Best Paper Award goes to Chenhao Lin, Jiongli Zhu, Chao Shen, Pengwei Hu, Qian Wang for their paper ELLG: Explainable Lesion Learning and Generation for Diabetic Retinopathy Detection. Congratulations! 
      </InlineNotification>
      <p>{`Below is the list of accepted papers:`}</p>
      <p>{`Nicholas Soures, David Chambers, Zachariah Carmichael, Anurag Daram, Kal Clark, Pankil Shah, Dimpy Shah, Lloyd Potter, Dhireesha Kudithipudi. SIRNET: Understanding Social Distancing Measures with Hybrid Neural Network Model for COVID-19 Infectious Spread. `}<a parentName="p" {...{
          "href": "/c95fd91e5ea9044450be2bf32fa33939/CameraReady_SIRNET.pdf"
        }}>{`Camera Ready Version`}</a></p>
      <p>{`Chenhao Lin, Jiongli Zhu, Chao Shen, Pengwei Hu, Qian Wang. ELLG: Explainable Lesion Learning and Generation for Diabetic Retinopathy Detection. `}<a parentName="p" {...{
          "href": "/5b1aa84bcd00a71de826000802315556/CameraReady_ELLG.pdf"
        }}>{`Camera Ready Version`}</a></p>
      <p>{`Tengteng Zhang, Yiqin Yu, Zefang Tang, Xiang Zhang, Shaochun Li. Unlocking the Power of Deep PICO Extraction: Step-wise Medical NER Identification. `}<a parentName="p" {...{
          "href": "/ad0b7e962f0a90ed5f1c60e5d647d2bd/CameraReady_PICO.pdf"
        }}>{`Camera Ready Version`}</a></p>
      <p>{`Akira Koseki, Reitaro Tokumasu, Daijo Inaguma. CVD prediction of CKD Patients using Window-based Laboratory Tests and Drug Usage Covariates. `}<a parentName="p" {...{
          "href": "/373fbd74ecbfe78f78e0010e1faa0a7b/CameraReady_CVD.pdf"
        }}>{`Camera Ready Version`}</a></p>
      <p>{`Xu Min, Yiqin Yu, Shiwan Zhao, Shaochun Li. Medical Outcome Prediction by Adaptive Knowledge Distillation. `}<a parentName="p" {...{
          "href": "/00b59b5b71b8fff3842f341ff85b53da/CameraReady_AKD.pdf"
        }}>{`Camera Ready Version`}</a></p>
    </PageDescription>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      